import React, { CSSProperties } from 'react'
import './InventoryOccupancyChart.scss'
import { InventoryBuildingModel } from '../models/inventory-buiding.model'
import { InventoryCityModel } from '../models/inventory-city.model'

type InventoryOccupancyItem = InventoryBuildingModel | InventoryCityModel

const getItemLabel = (item: InventoryOccupancyItem): string => {
  return 'buildingName' in item ? item.buildingName : item.cityName
}

const InventoryOccupancyChart: React.FC<{
  inventoryItem: InventoryOccupancyItem
  selectInventoryItem?: (inventoryName: string) => void
}> = ({ inventoryItem, selectInventoryItem }) => {
  const getGradient = (occupiedPercentage: number): CSSProperties => {
    const realPercentage = occupiedPercentage * 100

    return {
      backgroundImage: `conic-gradient(
                    #90E0EF 0%,
                    #2A77B6 ${realPercentage}%,
                    #E5E6EB ${realPercentage}%,
                    #E5E6EB 100%
    )`,
    }
  }

  const getDisplayedPercentage = (occupiedPercentage: number): string => {
    return `${Math.round(occupiedPercentage * 100)}%`
  }

  return (
    <div
      className='InventoryOccupancyChart'
      onClick={() => {
        if (selectInventoryItem) {
          selectInventoryItem(getItemLabel(inventoryItem))
        }
      }}
    >
      <div
        className='InventoryOccupancyChart__wheel'
        style={getGradient(inventoryItem.occupiedPercentage)}
      >
        <p className='InventoryOccupancyChart__value'>
          {getDisplayedPercentage(inventoryItem.occupiedPercentage)}
        </p>
      </div>

      <p className='InventoryOccupancyChart__description'>{getItemLabel(inventoryItem)}</p>
      <p className='InventoryOccupancyChart__description'>
        {inventoryItem.allocatedSlots} / {inventoryItem.totalSlots}
      </p>
    </div>
  )
}

export default InventoryOccupancyChart
